import React from "react";
import { LineChart, Wallet, CreditCard, Scale, BookOpen, Home } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { CategoryResources } from "@/components/CategoryResources";
import { SectionHeading } from "@/components/ResourceCard";
import { IMG } from "@/lib/assets";

const TOPICS = [
  { icon: CreditCard, title: "Understanding Credit Reports", desc: "What's in your report, how to read it, and how to dispute errors." },
  { icon: LineChart, title: "Credit Scores & Financial Habits", desc: "What shapes your score and the habits that strengthen it over time." },
  { icon: Wallet, title: "Budgeting & Savings", desc: "Build a realistic spending plan and grow an emergency fund." },
  { icon: Scale, title: "Debt Management Education", desc: "Strategies to reduce debt and understand your options." },
  { icon: BookOpen, title: "Consumer Financial Rights", desc: "Know your rights under consumer financial protection laws." },
  { icon: Home, title: "Preparing for Homeownership", desc: "Get financially ready for the path to owning a home." },
];

export default function FinancialWellness() {
  return (
    <main>
      <PageHero overline="Financial Wellness Center" image={IMG.finance1}
        title="Education that builds lasting financial health"
        subtitle="Learn about credit, budgeting, debt, and your consumer rights. Purely educational — we never advertise credit repair, tradeline sales, or commercial financial products." />

      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 lg:py-20">
        <SectionHeading overline="Learn" title="Financial education topics"
          subtitle="Free, unbiased education to help you take control of your financial future." />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TOPICS.map((t, i) => (
            <div key={i} className="card-hover bg-white rounded-2xl border border-slate-200 p-7">
              <div className="h-13 w-13 h-14 w-14 rounded-2xl bg-navy-900 text-gold-light flex items-center justify-center mb-5"><t.icon className="h-7 w-7" /></div>
              <h3 className="font-display text-lg font-bold text-navy-900">{t.title}</h3>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-navy-900 py-16 lg:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-8 text-center">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-gold-light">Our Promise</span>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-white mt-4">Education first — always</h2>
          <p className="mt-5 text-lg text-slate-300 max-w-3xl mx-auto leading-relaxed">
            We provide financial education and connect you to trusted, free resources from organizations like the CFPB.
            We do not sell credit repair, credit restoration, tradelines, monitoring subscriptions, or any commercial financial products.
          </p>
        </div>
      </section>

      <CategoryResources category="credit-financial-education" overline="Trusted Resources"
        title="Credit & financial education resources"
        subtitle="Free, verified educational tools from recognized providers."
        categoryName="Financial Education" />
    </main>
  );
}
